import { computed as A, toValue as K, ref as ve, onMounted as gn, nextTick as rt, onActivated as Sn, onBeforeUnmount as yn, watch as B, markRaw as In, shallowReactive as wn } from "vue";
import { r as Oe } from "./keyField-D6okV6nC.js";
function st(n, o, s) {
  return Oe(n, o, s);
}
function Be(n, o) {
  return n.map((s, a) => st(s, a, o));
}
function xn(n, o, s) {
  const a = [], l = [];
  for (let f = 0; f < n.length; f++) {
    const I = n[f], x = st(I, f, o), T = s(I, f, x);
    a.push(x), l.push(typeof T == "number" && T > 0 ? T : null);
  }
  return {
    keys: a,
    sizes: l
  };
}
function bn(n, o, s) {
  if (!n || n.keys.length !== o.length || n.sizes.length !== o.length)
    return !1;
  for (let a = 0; a < o.length; a++)
    if (n.keys[a] !== st(o[a], a, s))
      return !1;
  return !0;
}
function zn(n, o, s) {
  if (!bn(n, o, s))
    return {};
  const a = {};
  for (let l = 0; l < n.keys.length; l++) {
    const f = n.sizes[l];
    typeof f == "number" && f > 0 && (a[n.keys[l]] = f);
  }
  return a;
}
function Mn(n, o) {
  if (!n.length || o.length <= n.length)
    return 0;
  const s = n[0], a = o.indexOf(s);
  if (a <= 0 || a + n.length < o.length && n.length > o.length - a)
    return 0;
  for (let l = 0; l < n.length; l++)
    if (o[a + l] !== n[l])
      return 0;
  return a;
}
function At(n, o, s, a, l, f = 0) {
  const I = l ?? "start";
  if (I === "nearest") {
    const x = s + a, T = n + o;
    return n >= s && T <= x ? null : n < s ? n + f : T - a + f;
  }
  return I === "end" ? n + o - a + f : I === "center" ? n + (o - a) / 2 + f : n + f;
}
function Tn(n) {
  return n.flowMode && n.direction === "vertical" && !n.gridItems ? "flow" : n.disableTransform ? "position" : "transform";
}
function En(n, o) {
  const s = o.direction === "vertical", a = o.mode ?? "transform", l = {
    visibility: n.nr.used ? "visible" : "hidden",
    pointerEvents: n.nr.used ? void 0 : "none"
  };
  if (a === "flow" ? l.display = n.nr.used ? void 0 : "none" : (l.position = "absolute", l.top = "0px", l.left = "0px", l.display = void 0), a === "position" ? (l[s ? "top" : "left"] = `${n.position}px`, l[s ? "left" : "top"] = `${n.offset}px`, l.transform = "none", l.willChange = "unset") : a === "transform" && (l.transform = s ? `translateY(${n.position}px) translateX(${n.offset}px)` : `translateX(${n.position}px) translateY(${n.offset}px)`, l.willChange = "transform"), o.gridItems && o.itemSize != null) {
    const f = o.itemSecondarySize || o.itemSize;
    l.width = `${s ? f : o.itemSize}px`, l.height = `${s ? o.itemSize : f}px`;
  }
  return l;
}
function Ut(n) {
  return A(() => K(n));
}
function Vn(n, o, s, a, l) {
  const f = Ut(n);
  return {
    el: A(() => {
      const I = f.value.el;
      return K(o ?? I);
    }),
    before: A(() => {
      const I = f.value.before;
      return K(s ?? I);
    }),
    after: A(() => {
      const I = f.value.after;
      return K(a ?? I);
    }),
    scrollParent: A(() => {
      const I = f.value.scrollParent;
      return K(I);
    }),
    callbacks: {
      onResize: () => {
        var I;
        return (I = (l == null ? void 0 : l.onResize) ?? f.value.onResize) == null ? void 0 : I();
      },
      onVisible: () => {
        var I;
        return (I = (l == null ? void 0 : l.onVisible) ?? f.value.onVisible) == null ? void 0 : I();
      },
      onHidden: () => {
        var I;
        return (I = (l == null ? void 0 : l.onHidden) ?? f.value.onHidden) == null ? void 0 : I();
      },
      onUpdate: (I, x, T, N) => {
        var ge;
        return (ge = (l == null ? void 0 : l.onUpdate) ?? f.value.onUpdate) == null ? void 0 : ge(I, x, T, N);
      }
    }
  };
}
const _n = {
  itemsLimit: 1e3
};
function $t(n) {
  return typeof window < "u" && n === window;
}
const Pn = (() => {
  if (typeof document > "u")
    return "negative";
  const n = document.createElement("div"), o = document.createElement("div");
  n.style.width = "4px", n.style.height = "1px", n.style.overflow = "auto", n.style.direction = "rtl", o.style.width = "8px", o.style.height = "1px", n.appendChild(o), document.body.appendChild(n), n.scrollLeft = -1;
  const s = n.scrollLeft < 0;
  return document.body.removeChild(n), s ? "negative" : "default";
})();
function pe(n, o, s) {
  return o !== "horizontal" || !s || $t(s) || getComputedStyle(s).direction !== "rtl" ? n : Pn === "negative" ? -n : n;
}
function Fn(n, o, s) {
  return pe(n, o, s);
}
function it(n, o, s, a) {
  const l = Fn(s, o, n), f = !!(a != null && a.smooth);
  if ($t(n)) {
    o === "vertical" ? n.scrollTo({
      top: l,
      behavior: f ? "smooth" : "auto"
    }) : n.scrollTo({
      left: l,
      behavior: f ? "smooth" : "auto"
    });
    return;
  }
  if (typeof n.scrollTo == "function") {
    n.scrollTo(o === "vertical" ? { top: l, behavior: f ? "smooth" : "auto" } : { left: l, behavior: f ? "smooth" : "auto" });
    return;
  }
  o === "vertical" ? n.scrollTop = l : n.scrollLeft = l;
}
function Ln(n, o, s, a) {
  if (s) {
    if (a && a !== window) {
      const l = a;
      return o === "vertical" ? l.clientHeight : l.clientWidth;
    }
    return o === "vertical" ? window.innerHeight : window.innerWidth;
  }
  return o === "vertical" ? n.clientHeight : n.clientWidth;
}
const Cn = /auto|scroll/;
function jt(n, o) {
  return n.parentNode === null ? o : jt(n.parentNode, [...o, n]);
}
function ot(n, o) {
  return getComputedStyle(n, null).getPropertyValue(o);
}
function Rn(n) {
  return ot(n, "overflow") + ot(n, "overflow-y") + ot(n, "overflow-x");
}
function Wn(n) {
  return Cn.test(Rn(n));
}
function kn(n) {
  if (!(n instanceof HTMLElement || n instanceof SVGElement))
    return;
  if (n.parentNode === null)
    return document.scrollingElement || document.documentElement;
  const o = jt(n.parentNode, []);
  for (let s = 0; s < o.length; s += 1)
    if (o[s] instanceof Element && Wn(o[s]))
      return o[s];
  return document.scrollingElement || document.documentElement;
}
function Nn(n, o) {
  if (o)
    return o;
  if (!n)
    return;
  const s = kn(n);
  if (s)
    return typeof window < "u" && window.document && (s === window.document.documentElement || s === window.document.body) ? window : s;
}
let lt = !1;
function Hn() {
  return lt;
}
if (typeof window < "u") {
  lt = !1;
  try {
    const n = Object.defineProperty({}, "passive", {
      get() {
        lt = !0;
      }
    });
    window.addEventListener("test", null, n);
  } catch {
  }
}
function D(n) {
  return typeof n == "number" ? n : null;
}
function An(n, o, s, a, l) {
  return typeof s == "number" ? s : typeof s == "function" ? s(n, o) || a || void 0 : a || (n == null ? void 0 : n[l ?? "size"]) || void 0;
}
function Bn(n, o, s, a, l, f) {
  return typeof s == "function" ? s(n, o) || a || Number(l) || 0 : a || (n == null ? void 0 : n[f ?? "size"]) || Number(l) || 0;
}
let Yn = 0;
const On = [];
function Un(n) {
  for (let o = 0; o < n.length; o++)
    n[o];
}
function $n(n, o) {
  return n && typeof n == "object" ? n[o] : void 0;
}
function Ye(n, o) {
  return n.map((s) => $n(s, o));
}
function jn(n, o, s, a) {
  if (n.length !== s.length || o.length !== a.length)
    return !1;
  for (let l = 0; l < n.length; l++)
    if (n[l] !== s[l] || o[l] !== a[l])
      return !1;
  return !0;
}
function Dn(n) {
  const o = n;
  o._vs_styleStamp++;
}
function Bt(n) {
  const o = n;
  o._vs_visibilityStamp++, o._vs_styleStamp++;
}
function Gn(n, o, s, a) {
  if (s) {
    for (const l of s)
      a(l);
    return;
  }
  for (let l = n; l < o; l++)
    a(l);
}
const Yt = 8, Ot = 1;
function Jn(n, o, s, a, l, f) {
  const I = Ut(n), x = Vn(I, o, s, a, l), T = A(() => {
    const e = K(v().items);
    return Un(e), e;
  }), N = ve([]), ge = ve(0), Se = ve(0), ye = ve(0), le = ve(!1);
  let G = 0, X = 0, ut = 0, at = 0, ct = !1, ee = null;
  const Ue = /* @__PURE__ */ new Map(), $e = /* @__PURE__ */ new Map();
  let Ee = !1, je = 0, dt = 0, De = !1, se = null, ue = null, q = null, Ge = 0, Ie = null, we = null, Ve = [], xe = [], te = null, Y = null, be = null, Xe = !1, ft = !1, mt = !1;
  const _e = /* @__PURE__ */ new Set(), Pe = ve({}), qe = [], ht = {
    accumulator: 0
  };
  function v() {
    return I.value;
  }
  function ae() {
    return (f == null ? void 0 : f.pageMode) ?? v().pageMode;
  }
  const M = A(() => K(v().enabled ?? !0)), ze = A(() => Nn(
    x.el.value,
    x.scrollParent.value
  )), Z = A(() => {
    const e = T.value;
    return e.length > 0 && typeof e[0] != "object";
  }), Me = A(() => {
    const e = v();
    if (D(e.itemSize) === null) {
      const r = T.value, i = Array.from({ length: r.length });
      ht.accumulator = 0, i[-1] = ht;
      const u = e.minItemSize, d = Pe.value, h = Z.value;
      let S = 1e4, p = 0, z;
      for (let c = 0, m = r.length; c < m; c++) {
        const V = h ? c : Oe(r[c], c, e.keyField);
        z = Bn(
          r[c],
          c,
          e.itemSize,
          d[V],
          u,
          e.sizeField
        ), z < S && (S = z), p += z;
        const E = qe[c] ?? (qe[c] = {
          accumulator: 0,
          size: void 0
        });
        E.accumulator = p, E.size = z, i[c] = E;
      }
      return qe.length = r.length, Ge = S, i;
    }
    return On;
  }), Dt = A(
    () => N.value.filter((e) => (e._vs_visibilityStamp, e.nr.used)).sort((e, t) => e.nr.index - t.nr.index)
  ), Gt = A(() => {
    const e = v(), t = Z.value ? null : e.keyField;
    return xn(T.value, t, (r, i, u) => An(
      r,
      i,
      e.itemSize,
      Pe.value[u],
      e.sizeField
    ));
  });
  function J(e = v()) {
    return e.direction ?? "vertical";
  }
  function ce(e = v()) {
    const t = J(e);
    let r = e.flowMode ?? !1;
    return r && t !== "vertical" && (ft || (console.warn("[vue-recycle-scroller] flowMode only supports vertical lists. Falling back to standard positioning."), ft = !0), r = !1), r && e.gridItems && (mt || (console.warn("[vue-recycle-scroller] flowMode does not support gridItems. Falling back to standard positioning."), mt = !0), r = !1), Tn({
      direction: t,
      disableTransform: e.disableTransform ?? !1,
      flowMode: r,
      gridItems: e.gridItems
    });
  }
  function vt() {
    N.value.sort((e, t) => e.nr.used !== t.nr.used ? e.nr.used ? -1 : 1 : e.nr.used && t.nr.used ? e.nr.index - t.nr.index : e.nr.id - t.nr.id);
  }
  function Ze(e) {
    const t = v();
    return Pe.value = zn(e, T.value, Z.value ? null : t.keyField), Object.keys(Pe.value).length > 0;
  }
  function pt(e) {
    let t = $e.get(e);
    return t || (t = [], $e.set(e, t)), t;
  }
  function Xt(e, t, r, i, u) {
    const d = In({
      id: Yn++,
      index: t,
      used: !0,
      key: i,
      type: u
    }), h = wn({
      item: r,
      position: 0,
      offset: 0,
      nr: d,
      _vs_styleStamp: 0,
      _vs_visibilityStamp: 0
    });
    return e.push(h), h;
  }
  function qt(e) {
    const t = pt(e);
    if (t && t.length) {
      const r = t.pop();
      return r.nr.used = !0, Bt(r), r;
    }
  }
  function gt(e, t) {
    const r = N.value, i = r.indexOf(e);
    if (i === -1)
      return;
    const u = Math.max(0, Math.min(t, r.length - 1));
    i !== u && (r.splice(i, 1), r.splice(u, 0, e));
  }
  function Zt(e) {
    gt(e, N.value.length - 1);
  }
  function Jt() {
    const e = N.value;
    let t = 0;
    for (; t < e.length && !e[t].nr.used; )
      t++;
    let r = 0;
    for (let i = t; i < e.length && e[i].nr.used; i++)
      r++;
    return {
      activeStart: t,
      activeCount: r,
      headInsertCount: 0
    };
  }
  function Qt(e, t, r) {
    let i = null;
    t < G ? (i = r.activeStart + r.headInsertCount, r.headInsertCount++, r.activeCount++) : t >= X && (i = r.activeStart + r.activeCount, r.activeCount++), i != null && gt(e, i);
  }
  function St(e, t = !1) {
    const r = e.nr.type;
    pt(r).push(e), e.nr.used = !1, e.position = v().hiddenPosition ?? -999999, Bt(e), Ue.delete(e.nr.key), t && Zt(e);
  }
  function Kt() {
    Ue.clear(), $e.clear();
    for (let e = 0, t = N.value.length; e < t; e++) {
      const r = N.value[e];
      if (r && r.item && r.item.virtualSticky) {
        Ue.set(r.nr.key, r);
        continue;
      }
      r && St(r);
    }
  }
  function Je(e) {
    let t = -1;
    return t = requestAnimationFrame(() => {
      _e.delete(t), e();
    }), _e.add(t), t;
  }
  function yt() {
    for (const e of _e)
      cancelAnimationFrame(e);
    _e.clear();
  }
  function It() {
    se && (clearTimeout(se), se = null), ue && (clearTimeout(ue), ue = null), q && (clearTimeout(q), q = null), Y && (clearTimeout(Y), Y = null), be && (clearTimeout(be), be = null);
  }
  function Qe() {
    var e, t;
    M.value && ((t = (e = x.callbacks).onResize) == null || t.call(e), le.value && L(!1));
  }
  function Ke() {
    if (!M.value)
      return;
    te && !Xe && ne();
    const e = v();
    if (!Ee) {
      if (Ee = !0, se)
        return;
      const t = () => Je(() => {
        Ee = !1;
        const { continuous: r } = L(!1, !0);
        r || (ue && clearTimeout(ue), ue = setTimeout(Ke, e.updateInterval + 100));
      });
      t(), e.updateInterval && (se = setTimeout(() => {
        se = null, Ee && t();
      }, e.updateInterval));
    }
  }
  function en(e, t) {
    var r, i, u, d;
    M.value && le.value && (e || t.boundingClientRect.width !== 0 || t.boundingClientRect.height !== 0 ? ((i = (r = x.callbacks).onVisible) == null || i.call(r), Je(() => {
      L(!1);
    })) : (d = (u = x.callbacks).onHidden) == null || d.call(u));
  }
  function tn() {
    return ze.value ?? window;
  }
  function Fe() {
    const e = x.before.value;
    if (!e)
      return 0;
    const t = v();
    return J(t) === "vertical" ? e.scrollHeight : e.scrollWidth;
  }
  function de() {
    const e = x.el.value;
    if (!e)
      return { start: 0, end: 0 };
    const t = v(), r = J(t), i = r === "vertical";
    let u;
    if (ae()) {
      const d = e.getBoundingClientRect(), h = i ? d.height : d.width, S = ze.value, p = !S || S === window, z = p ? 0 : S.getBoundingClientRect().top, c = p ? 0 : S.getBoundingClientRect().left, m = p ? window.innerHeight : S.clientHeight, V = p ? window.innerWidth : S.clientWidth;
      let E = i ? -(d.top - z) : -(d.left - c), C = i ? m : V;
      E < 0 && (C += E, E = 0), E + C > h && (C = h - E), u = {
        start: E,
        end: E + C
      };
    } else i ? u = {
      start: e.scrollTop,
      end: e.scrollTop + e.clientHeight
    } : u = {
      start: pe(e.scrollLeft, r, e),
      end: pe(e.scrollLeft, r, e) + e.clientWidth
    };
    return u;
  }
  function nn() {
    const e = x.el.value;
    if (!e)
      return { start: 0, end: 0 };
    const t = v();
    if (J(t) === "vertical") {
      const r = pe(e.scrollLeft, "horizontal", e);
      return {
        start: r,
        end: r + e.clientWidth
      };
    }
    return {
      start: e.scrollTop,
      end: e.scrollTop + e.clientHeight
    };
  }
  function rn(e, t, r, i) {
    var S, p, z, c;
    const u = Fe(), d = e.start - i - u, h = e.end + i - u;
    if (G > 0) {
      const m = ((S = r[G - 1]) == null ? void 0 : S.accumulator) ?? 0;
      if (d <= m)
        return !0;
    }
    if (G < t - 1) {
      const m = ((p = r[G]) == null ? void 0 : p.accumulator) ?? Number.POSITIVE_INFINITY;
      if (d > m)
        return !0;
    }
    if (X > 1) {
      const m = ((z = r[X - 2]) == null ? void 0 : z.accumulator) ?? 0;
      if (h <= m)
        return !0;
    }
    if (X < t) {
      const m = ((c = r[X - 1]) == null ? void 0 : c.accumulator) ?? Number.POSITIVE_INFINITY;
      if (h > m)
        return !0;
    }
    return !1;
  }
  function Le(e) {
    const t = v(), r = D(t.itemSize);
    if (r !== null)
      return r;
    const i = Me.value[e];
    return (i == null ? void 0 : i.size) || Number(t.minItemSize) || 0;
  }
  function on(e) {
    const t = v();
    return En(e, {
      direction: J(t),
      mode: ce(t),
      itemSize: D(t.itemSize),
      gridItems: t.gridItems,
      itemSecondarySize: t.itemSecondarySize
    });
  }
  function U(e) {
    var u;
    const t = v(), r = t.gridItems || 1, i = D(t.itemSize);
    return e <= 0 ? 0 : i !== null ? Math.floor(e / r) * i : ((u = Me.value[e - 1]) == null ? void 0 : u.accumulator) || 0;
  }
  function wt(e) {
    const t = v(), r = T.value.length, i = t.gridItems || 1, u = D(t.itemSize);
    if (!r)
      return 0;
    if (u !== null) {
      const p = Math.floor(e / u) * i;
      return Math.min(Math.max(p, 0), r - 1);
    }
    let d = 0, h = r - 1, S = 0;
    for (; d <= h; ) {
      const p = Math.floor((d + h) / 2);
      U(p) <= e ? (S = p, d = p + 1) : h = p - 1;
    }
    return S;
  }
  function ne() {
    Y && (clearTimeout(Y), Y = null), te = null;
  }
  function ln() {
    Y && clearTimeout(Y), Y = setTimeout(() => {
      te = null, Y = null;
    }, 150);
  }
  function sn(e, t) {
    if (!e.length) {
      ne();
      return;
    }
    const r = Math.max(de().start - Fe(), 0), i = Math.min(wt(r), e.length - 1), u = e[i], d = t ? Oe(u, i, t) : i, h = Fe() + U(i);
    te = {
      key: d,
      offset: de().start - h
    };
  }
  function xt(e) {
    if (!te)
      return !1;
    const t = v(), r = e ?? T.value, i = Z.value ? null : t.keyField, d = Be(r, i).indexOf(te.key);
    if (d === -1)
      return ne(), !1;
    const h = Fe() + U(d) + te.offset, S = de().start;
    return Math.abs(h - S) < 0.5 ? !1 : (Xe = !0, Ce(h), Je(() => {
      Xe = !1;
    }), !0);
  }
  function Te() {
    if (fe(), !M.value)
      return;
    const e = ae() ? tn() : x.el.value;
    e && (Ie = e, Ie.addEventListener("scroll", Ke, Hn() ? { passive: !0 } : !1), ae() && e === window && (we = e, we.addEventListener("resize", Qe)));
  }
  function fe() {
    Ie && (Ie.removeEventListener("scroll", Ke), Ie = null), we && (we.removeEventListener("resize", Qe), we = null);
  }
  function un(e, t, r, i, u, d) {
    const h = Math.ceil(e / t) * r, S = Math.max(0, Math.floor(u.start / r)), p = Math.min(Math.ceil(u.end / r), Math.ceil(e / t)), z = Math.max(0, Math.floor(d.start / i)), c = Math.min(Math.ceil(d.end / i), t), m = [];
    for (let C = S; C < p; C++) {
      const me = C * t;
      for (let w = z; w < c; w++) {
        const g = me + w;
        if (g >= e)
          break;
        m.push(g);
      }
    }
    const V = m[0] ?? 0, E = m.at(-1) ?? -1;
    return {
      renderedIndices: m,
      startIndex: V,
      endIndex: E + 1,
      visibleStartIndex: V,
      visibleEndIndex: E,
      totalSize: h
    };
  }
  function an() {
    const e = v(), t = D(e.itemSize);
    if (!e.gridItems || t == null)
      return !1;
    const r = x.el.value;
    if (!r)
      return !1;
    const i = e.itemSecondarySize || t, u = J(e) === "vertical" ? r.clientWidth : r.clientHeight;
    return i * e.gridItems > u;
  }
  function bt(e, t, r, i) {
    if (Math.abs(e - t) !== 1 || t < 0 || t >= r)
      return e;
    const u = e > t ? U(t) + Le(t) : U(t);
    return Math.abs(u - i) <= Yt ? t : e;
  }
  function zt(e, t, r, i, u) {
    if (Math.abs(e - t) !== 1)
      return e;
    const d = u ? t - 1 : t;
    if (d < 0 || d >= r)
      return e;
    const h = e > t ? U(d) + Le(d) : U(d);
    return Math.abs(h - i) <= Yt ? t : e;
  }
  function cn(e, t, r) {
    const i = {
      ...e,
      visibleStartIndex: bt(e.visibleStartIndex, ut, t, r.rawViewportStart),
      visibleEndIndex: zt(e.visibleEndIndex, at, t, r.rawViewportEnd, !1),
      startIndex: bt(e.startIndex, G, t, r.renderStart),
      endIndex: zt(e.endIndex, X, t, r.renderEnd, !0)
    };
    i.startIndex > i.visibleStartIndex && (i.startIndex = i.visibleStartIndex);
    const u = Math.min(t, i.visibleEndIndex + 1);
    return i.endIndex < u && (i.endIndex = u), i.endIndex < i.startIndex && (i.endIndex = i.startIndex), i;
  }
  function L(e, t = !1) {
    var Vt, _t, Pt, Ft, Lt, Ct, Rt, Wt, kt;
    if (!M.value)
      return { continuous: !0 };
    const r = v(), i = D(r.itemSize), u = r.gridItems || 1, d = r.itemSecondarySize || i || 0, h = Ge, S = r.typeField, p = Z.value ? null : r.keyField, z = T.value, c = z.length, m = Me.value, V = Ue, E = N.value;
    let C = null, me = null, w, g, H, _, P;
    const hn = i !== null || c === 0 || m[c - 1] != null;
    if (!c || !hn)
      !c || !ee ? w = g = _ = P = H = 0 : (w = Math.min(ee.startIndex, c), g = Math.min(ee.endIndex, c), _ = Math.min(ee.visibleStartIndex, c), P = Math.min(ee.visibleEndIndex, c), H = ((Vt = m[c - 1]) == null ? void 0 : Vt.accumulator) ?? ee.totalSizeValue);
    else if (De)
      w = _ = 0, g = P = Math.min(r.prerender, z.length), H = 0;
    else {
      const b = de(), W = nn(), $ = je, j = dt, R = { ...b }, he = { ...W };
      if (t) {
        let F = b.start - $;
        F < 0 && (F = -F);
        let oe = W.start - j;
        oe < 0 && (oe = -oe);
        const Ne = i === null && rn(b, c, m, r.buffer), k = i === null && (F >= h || Ne) || i !== null && F >= i, He = u > 1 && i != null && oe >= d;
        if (!k && !He)
          return {
            continuous: !0
          };
      }
      je = b.start, dt = W.start;
      const Q = r.buffer;
      R.start -= Q, R.end += Q, he.start -= Q, he.end += Q;
      let O = 0;
      const Nt = x.before.value;
      Nt && (O = Nt.scrollHeight, R.start -= O);
      const Ht = x.after.value;
      if (Ht) {
        const F = Ht.scrollHeight;
        R.end += F;
      }
      const pn = ce(r) === "flow" && i === null && !t && ct && Math.abs(b.start - $) <= Ot && Math.abs(W.start - j) <= Ot;
      if (i === null) {
        let F, oe = 0, Ne = c - 1, k = ~~(c / 2), He;
        do
          He = k, F = ((_t = m[k]) == null ? void 0 : _t.accumulator) ?? 0, F < R.start ? oe = k : k < c - 1 && (((Pt = m[k + 1]) == null ? void 0 : Pt.accumulator) ?? Number.POSITIVE_INFINITY) > R.start && (Ne = k), k = ~~((oe + Ne) / 2);
        while (k !== He);
        for (k < 0 && (k = 0), w = k, H = ((Ft = m[c - 1]) == null ? void 0 : Ft.accumulator) ?? 0, g = k; g < c && (((Lt = m[g]) == null ? void 0 : Lt.accumulator) ?? 0) < R.end; g++) ;
        for (g === -1 ? g = z.length - 1 : (g++, g > c && (g = c)), _ = w; _ < c && O + (((Ct = m[_]) == null ? void 0 : Ct.accumulator) ?? Number.POSITIVE_INFINITY) < R.start; _++) ;
        for (P = _; P < c && O + (((Rt = m[P]) == null ? void 0 : Rt.accumulator) ?? 0) < R.end; P++) ;
        if (pn) {
          const Ae = cn({
            startIndex: w,
            endIndex: g,
            visibleStartIndex: _,
            visibleEndIndex: P
          }, c, {
            rawViewportStart: b.start - O,
            rawViewportEnd: b.end - O,
            renderStart: b.start - Q - O,
            renderEnd: b.end + Q - O
          });
          w = Ae.startIndex, g = Ae.endIndex, _ = Ae.visibleStartIndex, P = Ae.visibleEndIndex;
        }
        ee = {
          startIndex: w,
          endIndex: g,
          visibleStartIndex: _,
          visibleEndIndex: P,
          totalSizeValue: H
        };
      } else if (u > 1) {
        const F = un(
          c,
          u,
          i,
          d,
          R,
          he
        );
        C = F.renderedIndices, me = new Set(C), w = F.startIndex, g = F.endIndex, _ = F.visibleStartIndex, P = F.visibleEndIndex, H = F.totalSize;
      } else {
        w = ~~(R.start / i * u);
        const F = w % u;
        w -= F, g = Math.ceil(R.end / i * u), _ = Math.max(0, Math.floor((R.start - O) / i * u)), P = Math.floor((R.end - O) / i * u), w < 0 && (w = 0), g > c && (g = c), _ < 0 && (_ = 0), P > c && (P = c), H = Math.ceil(c / u) * i;
      }
    }
    const vn = typeof r.itemsLimit == "number" && r.itemsLimit > 0 ? r.itemsLimit : _n.itemsLimit;
    ((C == null ? void 0 : C.length) ?? g - w) > vn && dn(), ge.value = H, Se.value = 0, ye.value = ce(r) === "flow" ? H : 0;
    let y;
    const et = w <= X && g >= G, Tt = ce(r) === "flow", tt = Tt && et && !e;
    let nt = null;
    if (!et || e)
      Kt();
    else {
      const b = (W) => {
        const $ = E[W];
        $ && (y = $, y.nr.used && ((me ? me.has(y.nr.index) : y.nr.index >= w && y.nr.index < g) || y.item && y.item.virtualSticky || St(y, tt)));
      };
      if (tt) {
        for (let W = E.length - 1; W >= 0; W--)
          b(W);
        nt = Jt();
      } else
        for (let W = 0, $ = E.length; W < $; W++)
          b(W);
    }
    let ie, We, ke = null, Et = 0;
    return Gn(w, g, C, (b) => {
      var he;
      const W = m[b] && m[b].size, $ = i || W || Ge || 1;
      ie = z[b];
      const j = p ? Oe(ie, b, p) : b;
      y = V.get(j);
      let R = !1;
      if (y)
        y.item !== ie && (y.item = ie), y.nr.used || console.warn(`Expected existing view's used flag to be true, got ${y.nr.used}`);
      else {
        if (We = ie[S], y = qt(We), y) {
          const Q = y.nr.index !== b || y.nr.key !== j;
          y.item = ie, y.nr.index = b, y.nr.key = j, y.nr.type !== We && console.warn("Reused view's type does not match pool's type"), Q && Dn(y);
        } else
          y = Xt(E, b, ie, j, We);
        V.set(j, y), R = !0;
      }
      i === null ? (y.position = ((he = m[b - 1]) == null ? void 0 : he.accumulator) || 0, y.offset = 0) : (y.position = Math.floor(b / u) * i, y.offset = b % u * d), nt && R && Qt(y, b, nt), ke ?? (ke = y.position), Et += $;
    }), Tt ? (ke == null ? (Se.value = 0, ye.value = H) : (Se.value = ke, ye.value = Math.max(0, H - ke - Et)), tt || vt()) : (Se.value = 0, ye.value = 0), G = w, X = g, ut = _, at = P, ct = !0, r.emitUpdate && ((kt = (Wt = x.callbacks).onUpdate) == null || kt.call(Wt, w, g, _, P)), ce(r) !== "flow" && (q && clearTimeout(q), q = setTimeout(Mt, r.updateInterval + 300)), {
      continuous: et
    };
  }
  function dn() {
    throw be = setTimeout(() => {
      be = null, console.warn("It seems the scroller element isn't scrolling, so it tries to render all the items at once.", "Scroller:", x.el.value), console.warn("Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport.");
    }), new Error("Rendered items limit reached");
  }
  function fn() {
    if (an())
      return !1;
    const e = N.value.filter(({ nr: t }) => t.used);
    for (let t = 1; t < e.length; t++)
      if (e[t].nr.index !== e[t - 1].nr.index + 1)
        return !0;
    return !1;
  }
  function Mt() {
    if (M.value) {
      if (ce() === "flow") {
        vt();
        return;
      }
      N.value.sort((e, t) => e.nr.index - t.nr.index), fn() && (L(!1), q && clearTimeout(q));
    }
  }
  function mn(e, t) {
    if (!M.value)
      return;
    const r = v(), i = J(r), u = x.el.value;
    if (!u)
      return;
    const d = Math.max(0, Math.min(e, T.value.length - 1)), h = de().start, S = Ln(u, i, r.pageMode, ze.value), p = U(d), z = Le(d), c = At(
      p,
      z,
      h,
      S,
      t == null ? void 0 : t.align,
      (t == null ? void 0 : t.offset) ?? 0
    );
    if (c == null)
      return;
    Ce(c, t);
    const m = D(r.itemSize);
    if (r.gridItems && m != null) {
      const V = x.el.value;
      if (!V)
        return;
      const E = r.gridItems, C = r.itemSecondarySize || m, w = d % E * C, g = i === "vertical" ? "horizontal" : "vertical", H = g === "horizontal" ? pe(V.scrollLeft, "horizontal", V) : V.scrollTop, _ = g === "horizontal" ? V.clientWidth : V.clientHeight, P = At(
        w,
        C,
        H,
        _,
        t == null ? void 0 : t.align,
        (t == null ? void 0 : t.offset) ?? 0
      );
      P != null && it(V, g, P, t);
    }
  }
  function Ce(e, t) {
    if (!M.value)
      return;
    const r = v(), i = J(r), u = x.el.value;
    if (u)
      if (ae()) {
        const d = ze.value ?? window, h = i === "vertical" ? "top" : "left", S = d === window, p = S ? document.scrollingElement || document.documentElement : d, z = p.getBoundingClientRect(), c = u.getBoundingClientRect(), m = S ? i === "vertical" ? window.scrollY : window.scrollX : pe(
          i === "vertical" ? p.scrollTop : p.scrollLeft,
          i,
          p
        ), V = c[h] - z[h];
        it(S ? window : p, i, e + m + V, t);
      } else
        it(u, i, e, t);
  }
  const re = v(), Re = T.value;
  return Ve = Be(Re, Re.length > 0 && typeof Re[0] != "object" ? null : re.keyField), xe = Ye(Re, re.typeField), re.cache && Ze(re.cache), M.value && re.prerender && (De = !0, L(!1)), re.gridItems && D(re.itemSize) == null && console.error("[vue-recycle-scroller] You must provide an itemSize when using gridItems"), gn(() => {
    M.value && (Te(), rt(() => {
      De = !1, L(!0), le.value = !0;
    }));
  }), Sn(() => {
    if (!M.value)
      return;
    const e = je;
    typeof e == "number" && rt(() => {
      Ce(e);
    });
  }), yn(() => {
    It(), yt(), fe();
  }), B(M, (e) => {
    e ? (Te(), rt(() => {
      L(!0), le.value = !0;
    })) : (fe(), It(), yt(), le.value = !1);
  }), B(() => v().cache, (e) => {
    M.value && (Ze(e), L(!0));
  }), B(() => K(v().items).slice(), (e, t) => {
    if (!M.value)
      return;
    const r = v(), i = Z.value ? null : r.keyField, u = Be(e, i), d = Ye(e, r.typeField), h = Ve, p = !jn(
      u,
      d,
      h,
      xe
    );
    r.shift && Mn(h, u) > 0 ? sn(t ?? [], i) : ne(), Ve = u, xe = d, xt(e), L(p);
  }), B(() => v().keyField, () => {
    if (!M.value)
      return;
    const e = v(), t = Z.value ? null : e.keyField;
    Ve = Be(T.value, t), xe = Ye(T.value, e.typeField), ne(), L(!0);
  }), B(() => v().typeField, () => {
    if (!M.value)
      return;
    const e = v();
    xe = Ye(T.value, e.typeField), ne(), L(!0);
  }), B(ae, () => {
    M.value && (fe(), Te(), L(!1));
  }), B(x.el, () => {
    M.value && (fe(), Te(), L(!1));
  }), B(ze, () => {
    !M.value || !ae() || (fe(), Te(), L(!1));
  }), B(Me, () => {
    M.value && (xt() && ln(), L(!1));
  }), B(() => v().gridItems, () => {
    M.value && L(!0);
  }), B(() => v().itemSecondarySize, () => {
    M.value && L(!0);
  }), {
    pool: N,
    visiblePool: Dt,
    totalSize: ge,
    startSpacerSize: Se,
    endSpacerSize: ye,
    ready: le,
    sizes: Me,
    simpleArray: Z,
    scrollToItem: mn,
    scrollToPosition: Ce,
    getScroll: de,
    findItemIndex: wt,
    getItemOffset: U,
    getItemSize: Le,
    getViewStyle: on,
    cacheSnapshot: Gt,
    restoreCache: Ze,
    updateVisibleItems: L,
    handleResize: Qe,
    handleVisibilityChange: en,
    sortViews: Mt
  };
}
export {
  Ut as a,
  Be as b,
  _n as c,
  zn as d,
  En as e,
  Mn as f,
  D as g,
  Tn as r,
  Jn as u
};
//# sourceMappingURL=useRecycleScroller-D_RDrEg2.js.map
